import { render, staticRenderFns } from "./TableHistorialRecibo.vue?vue&type=template&id=7e980414&"
import script from "./TableHistorialRecibo.vue?vue&type=script&lang=js&"
export * from "./TableHistorialRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports